<template>
	<v-dialog :value="value" @input="$emit('input')" >
      <v-card> 
	      <v-toolbar class="lighten-2 noshadow">
	          <v-toolbar-title> <h5 class="modal-title" id="exampleModalLabel">Schedule Filter</h5></v-toolbar-title>
	          <v-spacer></v-spacer>
	           <v-btn icon @click.native="close">
	            <v-icon>close</v-icon>
	          </v-btn>
	        </v-toolbar>
	        <form role="form" method="post" ref="myForm" @submit.prevent="saveAction" @keydown.enter.prevent.stop="saveAction">
       			 <v-card-title primary-title> 
       			 	   <label id="reservation-error" class="errorCus" for="christmas-shopper-reservation" v-if="error">End date must be after start date</label>
       			 
           
	                <div class="form-group col-sm-6 col-12" >
	                	 <!-- <label for="input_enddate" class="col-sm-2 col-form-label">Start Date</label> -->
	                	 <v-menu
				            ref="menu1"
				            :close-on-content-click="false"
				            v-model="menu1"
				            :nudge-right="40"
				            lazy
				            transition="scale-transition"
				            offset-y
				            full-width
				            max-width="290px"
				            min-width="290px"
				          >
				           <!--  -->
				            <v-text-field
				              slot="activator"
							
				              label="Start Date"
				              persistent-hint
				              prepend-icon="event"
				            	:value="computedDateFormatted"
				            ></v-text-field> 
				      		 <v-date-picker v-model="s_date" no-title @input="$refs.menu1.save(s_date)"
					        ></v-date-picker>
				          <!--   <v-date-picker :value="new Date()"  no-title @input="menu1 = false" ></v-date-picker> -->
				          </v-menu>

			        </div>
			        <div class="form-group col-sm-6 col-12" >
		               
				                <v-menu
				                ref="menu"
						          lazy
						          :close-on-content-click="false"
						          v-model="menu"
						          transition="scale-transition"
						          offset-y
						          full-width
						          :nudge-right="40"
						          min-width="290px">
				                	<v-text-field
									
						            slot="activator"
            						persistent-hint
           							:value="computedDateFormattedMomentEndDate"
						            label="End Date"

						            prepend-icon="event"
						            
						            ></v-text-field>
				                	<v-date-picker v-model="e_date" no-title  @input="$refs.menu.save(e_date)"  show-current="edate"></v-date-picker>
				                </v-menu>
				              <!--    -->
			            </div>
			        </div>
       		 	</v-card-title>
		       <v-card-actions class="modal-footer">
	        		<v-spacer></v-spacer>
		           
		            <v-btn  type="submit"   color="info"  class="btn-info waves-effect waves-light ">Apply</v-btn>
		           
		        </v-card-actions>
       		</form>
      </v-card>
    </v-dialog>
</template>
<style scoped>

	input[type=date], input[type=datetime-local], input[type=month], input[type=time] {
	    -webkit-appearance: listbox;
	}
	.form-control {
	    color: #67757c;
	    min-height: 38px;
	    display: initial;
	}
	.form-control {
	    box-shadow: inset 0 2px 4px 0 hsla(0, 0%, 0%, 0.08);
	}
	.form-control {
	    display: block;
	    width: 100%;
	    padding: .375rem .75rem;
	    font-size: 1rem;
	    line-height: 1.5;
	    color: #495057;
	    background-color: #fff;
	    background-clip: padding-box;
	    border: 1px solid #ced4da;
	    border-radius: .25rem;
	    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	}
	.v-text-field{
		/* width: 300px;
		 margin-left: 15px;*/
	}
	/*.v-card__title{
		padding: 0px !important;
	}*/
</style>
<script>
    import { loginService } from '@/components/_service/Users.js'
    
    import { format,isWithinRange,getTime } from 'date-fns';
  	export default {
	   props:['value','flightId','modalTitle','sdate','edate'],
	 
	    data () {
	      	return {
	      		//date: '2018-03-02',
	      		dateFormatted:null,

		      	id:this.flightId,
		        title:"",
		        detail:{},
		        isReject:false,
		        flat_input_active: false,
		        s_date:null,
			    e_date:null,
			
			    menu1: false,
			    menu: false,
			    // menu2: false,
			    loading:true,
			    search:{},
			    error:false
			}
	    },
	  
	    methods: {
	    	selectdate(sdate){
					return '2019-07-07'
				},
	    	
		    onFocus: function(event) {
		            event.target.focus()
		            this.isReject = false
		            this.flat_input_active = true;
		    },
	        close: function () {
	       	//  this.id = ""
	     		//  this.approve_remark = ""
	         // debugger
	          this.detail={}
	          this.$emit('input')
	        },
	    
	        saveAction(e){
	       
				const stDate = format(new Date(this.s_date),'YYYYMMDD') // moment(this.input_startdate).format('YYYYMMDD')
				const edDate =format(new Date(this.e_date),'YYYYMMDD')
				var arr = [stDate,edDate];
				this.search={stDate,edDate,"id":this.flightId,page:""}
				
				
	        	if (this.modalTitle == "flightReport"){
	        // 		if (this.check2Date() === false){
	        // 			this.error = true
	        // 			return;
	        			
	        // 		}else{
	        // 			this.$store.dispatch('flightFilterDate', this.search)
			      //       .then(() => {
 								// this.$router.push({ path: `/report/${this.flightId}?q=${arr}&page=1` })
 								//  //window.location.reload();
			      //      		 }
			      //           )
			      //          .catch(err => {
			      //             console.log(err )
			                 
			      //          })
			      //          .finally(() => this.loading = false)
			               
			      //         }
			      //       this.close();

	        	}else if(this.modalTitle=="camReport"){
	        		if (this.check2Date() === false){
	        			this.error = true
	        			return;
	        			
	        		}else{
	        			
	        			this.$store.dispatch('campReportdetail', this.search)
			            .then(() => {
									this.$router.push({ path: `/reportfull/${this.flightId}?q=${arr}` })
			           			}
			                 
			                )
			               .catch(err => {
			                  console.log(err )
			                 
			               })
			               .finally(() => this.loading = false)
			               
			              }
			            this.close();

	        	}
				e.preventDefault();
	    		  	        			
	        	
	        	//debugger
	           
	          
	        },
	        check2Date(){

				const stDate = this.s_date; //format(new Date(this.sdate),'DD-MM-YYYY') // moment(this.input_startdate).format('YYYYMMDD')
				const edDate =  this.e_date; //format(new Date(this.input_enddate),'DD-MM-YYYY')
			
				let start = stDate.split("-")
				let end = edDate.split("-")
				let from = getTime(new Date(start[0], start[1], start[2]))
				let to = getTime(new Date(end[0], end[1], end[2]))
				
				
				if (from.toString() > to.toString()){
				
					return false
				}else {
					return true
				}
		
	        },
			 checkEnteredDates(stdateval,endateval){
				 //seperate the year,month and day for the first date
				 var stryear1 = stdateval.substring(6);
				 var strmth1  = stdateval.substring(0,2);
				 var strday1  = stdateval.substring(5,3);
				 var date1    = new Date(stryear1 ,strmth1 ,strday1);
				 
				 //seperate the year,month and day for the second date
				 var stryear2 = endateval.substring(6);
				 var strmth2  = endateval.substring(0,2);
				 var strday2  = endateval.substring(5,3);
				 var date2    = new Date(stryear2 ,strmth2 ,strday2 );
				 
				 var datediffval = (date2 - date1 )/864e5;
				 
				 if(datediffval <= 0){
				  alert("Start date must be prior to end date");
				  return false;
				 }
				 return true;
				
			},
	        formatDate (date) {
			  
			      return format(date, 'DD MMM, YYYY')
		    },
		    parseDate (date) {
		      if (!date) return null

		      const [month, day, year] = date.split('/')
		      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
		    },
		     isValidDate(strDate) {
			    var myDateStr= new Date(strDate);
			    if( ! isNaN ( myDateStr.getMonth() ) ) {
			       return true;
			    }
			    return false;
			},


				         
	     },
	     updated(){
	     	
	     	//this.s_date = this.sdate;
	     	// if(this.$route.query.page){
			
			if(this.$route.query.q){

				//console.log("got search")
				//console.log(this.s_date)
				this.s_date = format(this.s_date,'YYYY-MM-DD')
				this.e_date = format(this.e_date,'YYYY-MM-DD')
			}else{
				//console.info('reset date')
					//console.log(this.s_date)
					//console.log(this.sdate)
				if (format(this.sdate,'YYYY-MM-DD') != format(this.s_date,'YYYY-MM-DD')){
					//console.log("khong bang nhau")
					//console.log(this.s_date)
					//console.log(this.sdate)
					//this.s_date =  format(this.sdate,'YYYY-MM-DD')
					
				}else{
					//console.log(" bang nhau")
				//	console.log(this.s_date)
				//	console.log(this.sdate)
				}
				if (format(this.edate,'YYYY-MM-DD') != format(this.e_date,'YYYY-MM-DD')){
					
					//this.e_date =  format(this.edate,'YYYY-MM-DD')
					
				}else{
					//console.log(" bang nhau edate")
					//console.log(this.e_date)
					//console.log(this.edate)
				}
				
				
			}
			
	    //	
	     	
	     },

	     

	     computed: {
	     
		    computedDateFormattedMomentEndDate () {
		    	// console.log(this.edate);
		    	// console.log(this.e_date);
		    	return format(this.e_date, 'D MMM, YYYY');
		    	  
		    },
	     	 computedDateFormatted () {
	     	 		// console.log(this.sdate);
	     	 		// console.log(this.s_date);
			      return format(this.s_date, 'D MMM, YYYY');
			 },
		  

	    },

	    created(){
	    	this.s_date = this.sdate;
	    	//console.log("sdate created" + this.sdate);

	    	this.e_date = this.edate;
	    	//console.log("edate created" +this.edate);
	    },
	  
	    
 	}

</script>